import { getStartFreeTrialUrl } from '@@/utils/LoginUtils';
import { useUserStore } from '@@/stores/User';
import { Pill } from '@@/components/Common/Pills.vue';

export function useCurrentHistoryToggle(location) {
  const route = useRoute();
  const userStore = useUserStore();
  const { isAllAccess, isGuest } = userStore;

  const showLoading = ref(false);
  const view = ref('Current');

  const views = computed(() => {
    const params = {
      isGuest: isGuest,
      query: { return_to: route?.fullPath },
    };
    const startFreeTrialUrl = getStartFreeTrialUrl(params);

    return [
      new Pill({
        text: 'Current',
      }),
      new Pill({
        isLocked: !isAllAccess,
        text: 'History',
        to: !isAllAccess ? startFreeTrialUrl : null,
      }),
    ];
  });

  const selectedView = computed(() => views.value.findIndex((v) => v.text === view.value));
  const loadingClassName = 'tw-absolute tw-inset-0 tw-z-20 tw-flex tw-items-center tw-w-full tw-h-full loading-background-color';

  const updateSelectedView = (newView) => {
    view.value = newView.text;

    if (view.value === 'History' && !isAllAccess) {
      return false;
    }

    if (view.value === 'History' && (!location.history_hourly || !location.history_semi_daily)) {
      showLoading.value = true;
    }

    return true;
  };

  return {
    isAllAccess,
    isGuest,
    loadingClassName,
    selectedView,
    showLoading,
    updateSelectedView,
    view,
    views,
  };
}
